/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

export enum ProfileTabs {
  PLATES = "plates",
  FOLLOWING = "following",
  FOLLOWERS = "followers",
}
